import React, { useState, useEffect } from "react";
import { db } from "../../../../backend/firebaseConfig";
import { doc, setDoc, onSnapshot } from "firebase/firestore";
import { Box, Stack } from "@mui/system";
import Text from "../../atoms/text/Text";
import { FormControl, Select as Selected, MenuItem, useMediaQuery } from "@mui/material";
import { color } from "framer-motion";
import { useTheme } from "@mui/material/styles";






const patientName =
  (typeof window !== "undefined" && window.patientName) ||
  "";

const lowerTeethSVG = [
  {
  id: "tooth_17",
  d: "M3256 4513 c-16 -8 -56 -23 -89 -32 -106 -29 -102 -74 8 -86 36 -3 65 -10 65 -15 0 -5 -29 -12 -65 -15 -109 -12 -115 -52 -11 -84 36 -11 79 -27 95 -36 46 -23 105 -19 138 9 27 24 28 27 28 126 0 99 -1 102 -28 126 -33 29 -96 32 -141 7z m129 -15"
},
  {
  id: "tooth_18",
  d: "M3260 4840 c-19 -10 -57 -24 -85 -31 -111 -26 -114 -89 -3 -89 50 0 80 -13 53 -24 -9 -3 -35 -6 -56 -6 -104 0 -103 -64 1 -85 19 -4 59 -18 88 -32 66 -31 110 -26 146 18 22 26 25 38 25 116 0 84 -1 87 -34 120 -39 39 -80 43 -135 13z m108 -5"
  },
  {
  id: "tooth_19",
  d: "M3250 5161 c-19 -10 -58 -24 -87 -31 -56 -13 -79 -31 -69 -55 7 -19 16 -22 89 -30 31 -4 57 -10 57 -15 0 -5 -29 -12 -65 -15 -106 -12 -115 -53 -18 -81 32 -9 75 -25 95 -35 53 -27 110 -25 145 5 27 24 28 27 28 126 0 99 -1 102 -28 126 -34 29 -96 32 -147 5z m135 -13"
  },
  {
  id: "tooth_20",
  d: "M3244 5474 c-21 -15 -63 -38 -93 -53 -63 -31 -81 -52 -62 -75 11 -13 26 -15 82 -10 81 8 94 -7 22 -26 -76 -19 -93 -28 -93 -49 0 -27 29 -41 82 -41 24 0 65 -7 92 -15 92 -28 162 13 159 94 -3 89 -19 144 -52 173 -41 36 -85 37 -137 2z m116 1"
  },
  {
    id: "tooth_21",
    d: "M3160 5791 c-8 -5 -50 -43 -92 -85 -110 -106 -106 -148 12 -105 33 12 64 18 68 14 4 -4 2 -9 -3 -11 -31 -12 -110 -72 -113 -86 -5 -27 31 -40 80 -28 24 5 69 10 101 10 37 0 70 6 87 17 52 30 65 94 30 151 -11 18 -20 40 -20 48 0 9 -15 31 -34 50 -35 35 -82 45 -116 25z m114 -43"
  },
  {
    id: "tooth_22",
    d: "M2909 6002 c-24 -21 -35 -43 -45 -88 -7 -32 -21 -80 -30 -105 -35 -91 7 -106 77 -28 54 62 71 52 28 -16 -55 -87 -17 -125 61 -60 24 20 60 45 81 55 83 43 102 113 48 175 -17 19 -37 35 -45 35 -7 0 -17 6 -21 14 -12 21 -64 46 -95 46 -16 0 -41 -12 -59 -28z m134 -23"
  },
  {
    id: "tooth_23",
    d: "M2612 6126 c-38 -33 -49 -78 -29 -126 8 -19 18 -63 22 -97 7 -64 22 -87 51 -81 11 2 23 24 34 66 10 34 20 66 24 69 3 3 6 -25 6 -64 0 -50 4 -74 15 -83 25 -21 44 -4 75 66 17 36 39 77 50 91 22 28 27 91 10 124 -17 31 -60 47 -146 54 -77 7 -81 6 -112 -19z m143 4"
    ,center: { cx: 3350, cy: 8550 }
  },
  {
    id: "tooth_24",
    d: "M2338 6192 c-44 -5 -78 -48 -78 -99 0 -24 7 -54 16 -67 8 -13 23 -52 32 -87 29 -107 75 -110 87 -5 10 101 24 86 37 -44 2 -19 9 -25 28 -25 26 0 39 18 63 95 9 25 22 65 31 89 20 52 8 103 -30 127 -23 15 -120 23 -186 16z m83 -29"
    ,center: { cx: 2300, cy: 9000 }
  },
  {
    id: "tooth_25",
    d: "M2020 6192 c-14 -2 -37 -15 -52 -30 -33 -31 -38 -85 -12 -135 9 -17 24 -58 33 -91 28 -103 75 -105 86 -4 4 35 10 67 13 73 8 13 20 -30 21 -77 1 -52 10 -68 36 -68 17 0 27 10 39 40 9 22 16 47 16 54 0 7 12 39 26 71 24 51 25 61 15 96 -7 22 -23 46 -36 55 -23 15 -129 24 -185 16z m81 -29"
    ,center: { cx: 2300, cy: 8700 }
  },
  {
    id: "tooth_26",
    d: "M1730 6141 c-54 -8 -85 -26 -99 -58 -18 -38 -13 -78 14 -118 14 -20 39 -66 55 -102 25 -55 33 -64 52 -61 21 3 23 9 28 83 5 74 6 78 18 52 6 -16 12 -31 12 -35 0 -4 5 -24 11 -44 8 -31 15 -38 34 -38 19 0 26 7 34 38 6 20 11 50 11 65 0 15 7 44 15 64 26 61 16 109 -29 145 -22 18 -72 21 -156 9z m142 -12"
    ,center: { cx: 2900, cy: 8700 }
  },
  {
    id: "tooth_27",
    d: "M1475 6010 c-90 -58 -111 -77 -124 -117 -13 -37 -13 -43 5 -74 11 -19 40 -45 65 -59 25 -14 63 -40 84 -57 42 -35 82 -43 91 -18 3 8 -8 39 -26 70 -17 30 -30 60 -28 66 2 7 25 -12 51 -41 74 -82 111 -51 68 59 -12 28 -21 61 -21 72 0 36 -31 89 -61 104 -38 20 -68 19 -104 -5z m95 -5"
    ,center: { cx: 2500, cy: 9000 }
  },
  {
    id: "tooth_28",
    d: "M1242 5785 c-28 -21 -92 -151 -92 -188 0 -15 12 -40 28 -58 27 -30 34 -32 123 -40 52 -4 102 -11 111 -14 23 -9 58 12 58 34 0 13 -19 30 -55 50 -30 17 -55 36 -55 42 0 6 6 9 13 7 112 -41 116 -41 131 -29 9 8 16 17 16 22 0 5 -38 48 -85 95 -76 77 -90 87 -128 91 -29 3 -49 -1 -65 -12z m179 -85"
  },
  {
  id: "tooth_29",
  d: "M1120 5473 c-24 -22 -33 -41 -42 -93 -6 -36 -11 -78 -10 -94 3 -72 71 -107 158 -81 27 8 68 15 92 15 53 0 82 14 82 40 0 22 -20 35 -71 44 -19 3 -44 13 -55 22 -17 14 -13 15 52 10 58 -5 74 -3 85 10 19 23 1 44 -62 75 -30 15 -72 38 -93 53 -51 35 -97 34 -136 -1z m131 -9"
},
{
  id: "tooth_30",
  d: "M1103 5156 c-27 -24 -28 -27 -28 -126 0 -99 1 -102 28 -126 35 -30 92 -32 145 -5 20 10 63 26 95 35 97 28 88 69 -18 81 -36 3 -65 10 -65 15 0 5 29 12 65 15 110 12 114 57 9 86 -33 9 -74 24 -91 33 -48 24 -106 21 -140 -8z m136 -6"
},
{
  id: "tooth_31",
  d: "M1105 4827 c-33 -33 -34 -36 -34 -120 0 -78 3 -90 25 -116 34 -41 81 -49 136 -23 24 11 70 28 102 39 69 21 92 46 62 69 -11 8 -40 14 -65 14 -53 0 -83 13 -56 24 9 3 36 6 59 6 23 0 51 6 62 14 31 24 6 48 -77 76 -41 14 -84 31 -96 38 -40 22 -82 15 -118 -21z m125 2"
},
{
  id: "tooth_32",
  d: "M1103 4506 c-27 -24 -28 -27 -28 -126 0 -99 1 -102 28 -126 34 -29 92 -32 140 -8 17 9 58 24 91 33 105 29 101 74 -9 86 -36 3 -65 10 -65 15 0 5 29 12 65 15 110 12 114 57 9 86 -33 9 -74 24 -91 33 -48 24 -106 21 -140 -8z m136 -6"
},
];




const upperTeethSVG = [
  { id: "tooth_1", d: "M1103 3856 c-27 -24 -28 -27 -28 -126 0 -99 1 -102 28 -126 34 -29 92 -32 140 -8 17 9 58 24 91 33 105 29 101 74 -9 86 -36 3 -65 10 -65 15 0 5 29 12 65 15 106 12 115 53 18 81 -32 9 -75 25 -95 35 -53 27 -110 25 -145 -5z m135 -5" },
  { id: "tooth_2", d: "M1134 3550 c-47 -19 -63 -55 -63 -147 0 -84 1 -87 34 -119 39 -40 76 -44 134 -14 21 10 60 24 87 31 111 27 112 89 2 89 -50 0 -80 13 -53 24 9 3 36 6 59 6 23 0 51 6 62 14 30 23 7 48 -62 69 -32 11 -77 27 -100 38 -43 20 -67 23 -100 9z m105 -25" },
  { id: "tooth_3", d: "M1103 3206 c-27 -24 -28 -27 -28 -126 0 -99 1 -102 28 -126 35 -30 92 -32 145 -5 20 10 60 24 89 31 56 13 79 31 69 55 -7 19 -16 22 -88 30 -32 4 -58 10 -58 15 0 5 29 12 65 15 106 12 115 53 18 81 -32 9 -75 25 -95 35 -53 27 -110 25 -145 -5z m120 2" },
  { id: "tooth_4", d: "M1130 2907 c-43 -15 -74 -67 -65 -112 3 -16 9 -52 14 -79 16 -97 98 -134 177 -80 21 15 63 38 93 53 63 31 81 52 62 75 -11 13 -26 15 -82 10 -81 -8 -94 7 -21 26 75 19 92 28 92 49 0 27 -29 41 -82 41 -24 0 -65 7 -92 15 -57 17 -51 17 -96 2z m102 -18" },
  { id: "tooth_5", d: "M1385 2620 c-16 -4 -59 -8 -95 -9 -65 -1 -99 -14 -127 -51 -19 -23 -15 -81 7 -118 11 -18 20 -40 20 -48 0 -29 65 -84 100 -84 43 0 54 7 143 93 109 107 105 149 -13 106 -33 -12 -63 -19 -66 -16 -4 3 19 22 50 42 65 41 78 62 51 81 -20 15 -25 15 -70 4z m70 -20" },
  { id: "tooth_6", d: "M1500 2405 c-24 -20 -60 -45 -81 -55 -83 -43 -102 -113 -48 -175 17 -19 37 -35 45 -35 7 0 17 -6 21 -14 12 -21 64 -46 95 -46 46 0 89 47 104 116 7 32 21 80 30 105 35 91 -7 106 -77 28 -54 -62 -71 -52 -28 16 55 87 17 125 -61 60z m75 15" },
  { id: "tooth_7", d: "M1722 2298 c-6 -7 -22 -39 -36 -71 -14 -32 -34 -70 -46 -84 -22 -28 -27 -91 -10 -124 17 -31 60 -47 146 -54 76 -7 81 -6 111 19 38 32 49 80 29 127 -7 19 -17 62 -21 96 -7 64 -22 87 -51 81 -11 -2 -23 -24 -34 -66 -10 -34 -20 -66 -24 -69 -3 -3 -6 25 -6 63 0 68 -10 94 -36 94 -6 0 -16 -6 -22 -12z m43 -85" },
  { id: "tooth_8", d: "M2002 2233 c-5 -10 -14 -40 -21 -67 -7 -27 -21 -66 -31 -87 -52 -101 1 -167 135 -167 40 0 82 6 97 14 59 30 74 95 39 163 -11 20 -28 63 -38 96 -13 43 -23 61 -37 63 -28 6 -46 -25 -46 -77 0 -53 -13 -83 -24 -56 -3 9 -6 35 -6 56 0 22 -5 49 -10 60 -13 24 -46 25 -58 2z m50 -49" },
  { id: "tooth_9", d: "M2332 2238 c-6 -7 -16 -36 -23 -63 -6 -28 -20 -67 -30 -87 -37 -74 -17 -144 47 -168 39 -15 165 -6 196 14 49 32 54 89 15 176 -9 19 -22 55 -29 79 -14 48 -36 68 -62 58 -10 -4 -16 -18 -16 -40 0 -46 -11 -97 -20 -97 -4 0 -12 30 -16 68 -8 57 -12 67 -30 70 -11 2 -26 -3 -32 -10z m49 -67" },
  { id: "tooth_10", d: "M2727 2303 c-4 -3 -7 -40 -7 -80 0 -73 -11 -90 -24 -36 -24 99 -26 103 -51 103 -19 0 -26 -7 -34 -37 -6 -21 -11 -50 -11 -65 0 -15 -7 -46 -16 -68 -21 -52 -12 -104 24 -137 26 -24 31 -25 112 -18 48 3 96 13 111 22 54 32 64 98 24 158 -14 20 -39 66 -55 101 -21 46 -34 64 -48 64 -10 0 -22 -3 -25 -7z m62 -65" },
  { id: "tooth_11", d: "M2904 2425 c-3 -8 8 -39 26 -70 17 -30 30 -60 28 -66 -2 -7 -25 12 -51 41 -74 82 -109 54 -69 -59 12 -31 23 -72 27 -92 10 -65 71 -110 128 -95 13 3 40 18 60 33 20 16 48 36 61 46 14 9 31 35 37 56 10 34 9 44 -8 73 -10 18 -39 44 -64 58 -25 14 -63 40 -84 58 -42 34 -82 42 -91 17z m82 -29" },
  { id: "tooth_12", d: "M3048 2619 c-33 -19 -21 -46 37 -78 30 -17 55 -36 55 -42 0 -6 -6 -9 -12 -7 -113 41 -117 41 -132 29 -9 -8 -16 -17 -16 -22 0 -5 38 -48 85 -95 72 -73 91 -87 125 -91 57 -8 85 15 125 101 42 88 44 116 7 157 -26 30 -34 32 -118 39 -49 5 -100 11 -114 14 -14 3 -33 1 -42 -5z m169 -23" },
  { id: "tooth_13", d: "M3270 2905 c-25 -8 -64 -15 -88 -15 -53 0 -82 -14 -82 -40 0 -22 20 -35 71 -44 19 -3 44 -13 55 -22 17 -14 13 -15 -52 -10 -58 5 -74 3 -85 -10 -19 -23 -1 -44 62 -75 30 -15 72 -38 93 -53 22 -15 53 -26 72 -26 45 0 92 41 99 88 3 20 10 56 16 79 23 102 -54 162 -161 128z m126 -31" },
  { id: "tooth_14", d: "M3260 3215 c-14 -8 -56 -24 -93 -35 -106 -33 -103 -73 8 -85 36 -3 65 -10 65 -15 0 -5 -26 -11 -57 -15 -73 -8 -82 -11 -89 -30 -10 -24 13 -42 69 -55 29 -7 69 -21 89 -31 53 -27 110 -25 145 5 25 22 28 31 31 105 4 89 -7 132 -42 156 -26 19 -93 19 -126 0z m125 -19" },
  { id: "tooth_15", d: "M3265 3541 c-22 -10 -67 -28 -99 -38 -69 -21 -92 -46 -62 -69 11 -8 40 -14 65 -14 53 0 83 -13 56 -24 -9 -3 -36 -6 -59 -6 -23 0 -51 -6 -62 -14 -31 -24 -6 -48 77 -76 41 -14 84 -31 96 -38 40 -22 82 -15 118 22 33 32 34 35 34 120 0 80 -2 89 -27 117 -36 39 -84 46 -137 20z m122 -24" },
  { id: "tooth_16", d: "M3256 3863 c-16 -8 -56 -23 -89 -32 -106 -29 -102 -74 8 -86 36 -3 65 -10 65 -15 0 -5 -29 -12 -65 -15 -110 -12 -114 -57 -9 -86 33 -9 74 -24 91 -33 48 -24 106 -21 140 8 27 24 28 27 28 126 0 99 -1 102 -28 126 -33 29 -96 32 -141 7z m129 -17" },


];


// Helper: Get tooth type (simple example)
function getToothType(toothId) {
  // You can expand this mapping for more specific names
  const toothTypes = {
    "tooth_1": "1.) 3rd Molar (Wisdom Tooth)",
    "tooth_2": "2.) 2nd Molar (12-yr Molar)",
    "tooth_3": "3.) 1st Molar (6-yr Molar)",
    "tooth_4": "4.) 2nd Bicuspid (2nd Premolar)",
    "tooth_5": "5.) 1st Bicuspid (1st Premolar)",
    "tooth_6": "6.) Cuspid (Canine)",
    "tooth_7": "7.) Lateral Incisor",
    "tooth_8": "8.) Central Incisor",
    "tooth_9": "9.) Central Incisor",
    "tooth_10": "10.) Lateral Incisor",
    "tooth_11": "11.) Cuspid (Canine)",
    "tooth_12": "12.) 1st Bicuspid (1st Premolar)",
    "tooth_13": "13.) 2nd Bicuspid (2nd Premolar)",
    "tooth_14": "14.) 1st Molar (6-yr Molar)",
    "tooth_15": "15.) 2nd Molar (12-yr Molar)",
    "tooth_16": "16.) 3rd Molar (Wisdom Tooth)",
    "tooth_17": "17.) 3rd Molar (Wisdom Tooth)",
    "tooth_18": "18.) 2nd Molar (12-yr Molar)",
    "tooth_19": "19.) 1st Molar (6-yr Molar)",
    "tooth_20": "20.) 2nd Premolar (2nd Bicuspid)",
    "tooth_21": "21.) 1st Premolar (1st Bicuspid)",
    "tooth_22": "22.) Cuspid (Canine)",
    "tooth_23": "23.) Lateral Incisor",
    "tooth_24": "24.) Central Incisor",
    "tooth_25": "25.) Central Incisor",
    "tooth_26": "26.) Lateral Incisor",
    "tooth_27": "27.) Cuspid (Canine)",
    "tooth_28": "28.) 1st Premolar (1st Bicuspid)",
    "tooth_29": "29.) 2nd Premolar (2nd Bicuspid)",
    "tooth_30": "30.) 1st Molar (6-yr Molar)",
    "tooth_31": "31.) 2nd Molar (12-yr Molar)",
    "tooth_32": "32.) 3rd Molar (Wisdom Tooth)"
  };
  return toothTypes[toothId] || "Tooth";
}

function getToothTypeHover(toothId) {
  // You can expand this mapping for more specific names
  const toothTypes = {
    "tooth_1": "1.) Third Molar",
    "tooth_2": "2.) Second Molar",
    "tooth_3": "3.) First Molar",
    "tooth_4": "4.) Second Bicuspid",
    "tooth_5": "5.) First Bicuspid",
    "tooth_6": "6.) Cuspid",
    "tooth_7": "7.) Lateral Incisor",
    "tooth_8": "8.) Central Incisor",
    "tooth_9": "9.) Central Incisor",
    "tooth_10": "10.) Lateral Incisor",
    "tooth_11": "11.) Cuspid",
    "tooth_12": "12.) First Bicuspid",
    "tooth_13": "13.) Second Bicuspid",
    "tooth_14": "14.) First Molar",
    "tooth_15": "15.) Second Molar",
    "tooth_16": "16.) Third Molar",
    "tooth_17": "17.) Third Molar",
    "tooth_18": "18.) Second Molar",
    "tooth_19": "19.) First Molar",
    "tooth_20": "20.) Second Premolar",
    "tooth_21": "21.) First Premolar",
    "tooth_22": "22.) Cuspid",
    "tooth_23": "23.) Lateral Incisor",
    "tooth_24": "24.) Central Incisor",
    "tooth_25": "25.) Central Incisor",
    "tooth_26": "26.) Lateral Incisor",
    "tooth_27": "27.) Cuspid",
    "tooth_28": "28.) First Premolar",
    "tooth_29": "29.) Second Premolar",
    "tooth_30": "30.) First Molar",
    "tooth_31": "31.) Second Molar",
    "tooth_32": "32.) Third Molar"
  };
  return toothTypes[toothId] || "Tooth";
}

// Helper: Get tooth side (left/right)
function getToothSide(toothId) {
  const num = parseInt(toothId.replace("tooth_", ""), 10);
  if (num >= 1 && num <= 8) return "Upper Right";
  if (num >= 9 && num <= 16) return "Upper Left";
  if (num >= 17 && num <= 24) return "Lower Left";
  if (num >= 25 && num <= 32) return "Lower Right";
  return "";
}

// Helper: Get tooth arch (upper/lower)
function getToothArch(toothId) {
  const num = parseInt(toothId.replace("tooth_", ""), 10);
  if (num >= 1 && num <= 16) return "Upper";
  if (num >= 17 && num <= 32) return "Lower";
  return "";
}

const DentalChart = ({ uid }) => {
  const [toothStatus, setToothStatus] = useState({});
  const [selectedTooth, setSelectedTooth] = useState(null);
  const [editing, setEditing] = useState(false);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.only('lg'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.only('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.only('sm'));

  // Fetch tooth status from Firestore
  useEffect(() => {
    if (uid) {
      const userRef = doc(db, "users", uid);
      const unsubscribe = onSnapshot(userRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setToothStatus(data.toothStatus || {});
        }
      }, (error) => {
        // Silently handle permission errors during sign-out
        if (error.code === 'permission-denied') {
          console.log('DentalChart listener stopped due to sign-out');
          return;
        }
        console.error('Error fetching dental chart:', error);
      });
      return () => unsubscribe();
    }
  }, [uid]);

  // Handle tooth click
  const handleToothClick = (toothId) => {
    setSelectedTooth(toothId);
  };

  // Handle status change
  const handleStatusChange = async (event) => {
    const status = event.target.value;
    const updatedStatus = { ...toothStatus, [selectedTooth]: status };
    setToothStatus(updatedStatus);

    // Save to Firestore
    try {
      await setDoc(doc(db, "users", uid), { toothStatus: updatedStatus }, { merge: true });
    } catch (error) {
      console.error("Error saving tooth status:", error);
    }
  };

  return (
  <Box
    sx={{
      background: "transparent",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      justifyItems: "center",
      overflowX: "hidden",
      // boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
      // padding: "32px 24px",
      maxWidth: 900,
      margin: "0 auto"
    }}
  >
    {/* Header row */}
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
      <span style={{ fontWeight: 700, fontSize: 22, color: "#3d342b" }}>
        {/* {patientName} */}
        
      </span>
    </div>
    {/* Main flex row */}

    <Stack
    direction="row">
      {/* Chart */}
      <Box
        sx={{
          // transform: selectedTooth ? "none" : "translateX(200px)",
          transition: "all 0.5s"
        }}>
          
        <svg
          width={
            isLargeScreen ? "390" : 
            isMediumScreen ? "300" : 
            isSmallScreen ? "200" : 
            "420"
          }
          height={isLargeScreen ? "600" : "650"}
          viewBox="600 3000 3400 2200" // <-- Zoomed-in region, adjust as needed
          style={{
            background: "#FEFEFE",
            borderRadius: "12px",
            margin: "0 auto"
          }}
              >
                {/* Render teeth as before */}
                {upperTeethSVG.map((tooth) => (
            <g key={tooth.id}>
              <path
                d={tooth.d}
                fill={ selectedTooth === tooth.id ? (
                  toothStatus[tooth.id] === "Cavity" ? "#9f4223ff" :
                  toothStatus[tooth.id] === "Extracted" ? "#474747ff" :
                  toothStatus[tooth.id] === "Impacted" ? "#c6c44bff" :
                  toothStatus[tooth.id] === "Root Canal" ? "#713e8aff" :
                  toothStatus[tooth.id] === "Crown" ? "#C5A572" :
                  toothStatus[tooth.id] === "Bridge" ? "#2C6785" :
                  toothStatus[tooth.id] === "Implant" ? "#c9b8b8ff" :
                  "#FEFEFE"
                  ) : 
                  toothStatus[tooth.id] === "Cavity" ? "rgba(159, 66, 35, .3)" : 
                  toothStatus[tooth.id] === "Extracted" ? "rgba(43, 43, 43, .3)" :
                  toothStatus[tooth.id] === "Impacted" ? "rgba(232, 229, 84, .3)" :
                  toothStatus[tooth.id] === "Root Canal" ? "rgba(113, 62, 138, .3)" :
                  toothStatus[tooth.id] === "Crown" ? "rgba(197, 165, 114, .3)" :
                  toothStatus[tooth.id] === "Bridge" ? "rgba(44, 103, 133, .3)" :
                  toothStatus[tooth.id] === "Implant" ? "rgba(201, 184, 184, .3)" :
                  "#FEFEFE"
                }
                stroke={
                  selectedTooth === tooth.id ? "#2C251E" : 
                    toothStatus[tooth.id] === "Cavity" ? "#7d341cff" :
                    toothStatus[tooth.id] === "Extracted" ? "#303030" :
                    toothStatus[tooth.id] === "Impacted" ? "#a3a14aff" :
                    toothStatus[tooth.id] === "Root Canal" ? "#573469ff" :
                    toothStatus[tooth.id] === "Crown" ? "#897450ff" :
                    toothStatus[tooth.id] === "Bridge" ? "#2C6785" :
                    toothStatus[tooth.id] === "Implant" ? "#6e6868ff" :
                    "#aaaaaaff"
                  }
                strokeWidth={25}
                onClick={() => handleToothClick(tooth.id)}
                style={{
                  cursor: "pointer",
                  filter: "none",
                  transition: "stroke 0.2s, stroke-width 0.2s, filter 0.2s"
                }}
              >
                <title styles={{
                  backgroundColor: "red"
                }}>{`${getToothTypeHover(tooth.id)} — ${toothStatus[tooth.id] || "Healthy"}`}</title>
              </path>
            </g>
          ))}

          {lowerTeethSVG.map((tooth) => (
            <g key={tooth.id}>
              <path
                d={tooth.d}
                fill={ selectedTooth === tooth.id ? (
                  toothStatus[tooth.id] === "Cavity" ? "#9f4223ff" :
                  toothStatus[tooth.id] === "Extracted" ? "#474747ff" :
                  toothStatus[tooth.id] === "Impacted" ? "#c6c44bff" :
                  toothStatus[tooth.id] === "Root Canal" ? "#713e8aff" :
                  toothStatus[tooth.id] === "Crown" ? "#C5A572" :
                  toothStatus[tooth.id] === "Bridge" ? "#2C6785" :
                  toothStatus[tooth.id] === "Implant" ? "#c9b8b8ff" :
                  "#FEFEFE"
                  ) : 
                  toothStatus[tooth.id] === "Cavity" ? "rgba(159, 66, 35, .3)" : 
                  toothStatus[tooth.id] === "Extracted" ? "rgba(43, 43, 43, .3)" :
                  toothStatus[tooth.id] === "Impacted" ? "rgba(232, 229, 84, .3)" :
                  toothStatus[tooth.id] === "Root Canal" ? "rgba(113, 62, 138, .3)" :
                  toothStatus[tooth.id] === "Crown" ? "rgba(197, 165, 114, .3)" :
                  toothStatus[tooth.id] === "Bridge" ? "rgba(44, 103, 133, .3)" :
                  toothStatus[tooth.id] === "Implant" ? "rgba(201, 184, 184, .3)" :
                  "#FEFEFE"
                }
                stroke={
                  selectedTooth === tooth.id ? "#2C251E" : 
                    toothStatus[tooth.id] === "Cavity" ? "#7d341cff" :
                    toothStatus[tooth.id] === "Extracted" ? "#303030" :
                    toothStatus[tooth.id] === "Impacted" ? "#a3a14aff" :
                    toothStatus[tooth.id] === "Root Canal" ? "#573469ff" :
                    toothStatus[tooth.id] === "Crown" ? "#897450ff" :
                    toothStatus[tooth.id] === "Bridge" ? "#2C6785" :
                    toothStatus[tooth.id] === "Implant" ? "#6e6868ff" :
                    "#aaaaaaff"
                  }
                strokeWidth={25}
                onClick={() => handleToothClick(tooth.id)}
                style={{
                  cursor: "pointer",
                  filter: "none",
                  transition: "stroke 0.2s, stroke-width 0.2s, filter 0.2s"
                }}
              >
                <title styles={{
                  backgroundColor: "red"
                }}>{`${getToothTypeHover(tooth.id)} — ${toothStatus[tooth.id] || "Healthy"}`}</title>
              </path>
            </g>
          ))}
        </svg>
      </Box>
      {/* Details card */}
      <Box
        sx={{
          flex: 1,
          background: "#FEFEFE",
          borderRadius: "14px",
          boxShadow: "0 0px 10px rgba(89, 84, 74, .5)",
          border: "1px solid #ede7df",
          padding: "30px",
          maxWidth: 300,
          minWidth: 300,
          transform: selectedTooth ? "none" : "translateX(150%)",
          display: selectedTooth ? "block" : "none",
          transition: "all 0.5s",
        }}
      >
        {selectedTooth ? (
          <>
            <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 18, color: "#3d342b" }}>
            <Text
              text={getToothType(selectedTooth)}
              variant="manageListName"/>
            </div>
            <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 12, color: "#2C251E" }}>Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "140px 1fr", rowGap: 10, columnGap: 8, paddingBottom: "20px" }}>
              <div style={{ color: "#59544A" }}>Left or Right</div>
              <div style={{ color: "#2C251E", fontWeight: 600 }}>{getToothSide(selectedTooth)}</div>
              <div style={{ color: "#59544A" }}>Upper or Lower</div>
              <div style={{ color: "#2C251E", fontWeight: 600 }}>{getToothArch(selectedTooth)}</div>
              <div style={{ color: "#59544A" }}>Status</div>
              <div style={{
                color:
                  toothStatus[selectedTooth] === "Cavity" ? "#9f4223ff" :
                  toothStatus[selectedTooth] === "Extracted" ? "#474747ff" :
                  toothStatus[selectedTooth] === "Impacted" ? "#c6c44bff" :
                  toothStatus[selectedTooth] === "Root Canal" ? "#713e8aff" :
                  toothStatus[selectedTooth] === "Crown" ? "#C5A572" :
                  toothStatus[selectedTooth] === "Bridge" ? "#2C6785" :
                  toothStatus[selectedTooth] === "Implant" ? "#928282ff" :
                  "#2C251E",
                fontWeight: 600
              }}>
                {toothStatus[selectedTooth] || "Healthy"}
              </div>
            </div>
                  <select
                    value={toothStatus[selectedTooth] || ""}
                    onChange={handleStatusChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "8px",
                      border: "1px solid #c7a76c",
                      fontSize: "16px",
                      background: "#f8f5ef",
                      color: "#3d342b",
                      marginBottom: "8px"
                    }}
                  >
                    <option value="">Healthy</option>
                    <option value="Cavity">Cavity</option>
                    <option value="Extracted">Extracted</option>
                    <option value="Impacted">Impacted</option>
                    <option value="Root Canal">Root Canal</option>
                    <option value="Crown">Crown</option>
                    <option value="Bridge">Bridge</option>
                    <option value="Implant">Implant</option>
                  </select>
                  <Stack
                  >
                  <button onClick={() => setEditing(false)} style={{
                    marginTop: 8,
                    background: "#1976d2",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "8px 18px",
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer"
                  }}>Save</button>
                  </Stack>
            
          </>
        ) : (
          <div style={{ color: "#888", fontSize: 18, marginTop: 80 }}>Select a tooth to view details.</div>
        )}
      </Box>
    </Stack>
  </Box>
);
};

export default DentalChart;